import dayjs from 'dayjs';

const ucFirst = (string = '') => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const ucFirstArray = (types) => {
    if (types.length > 0) {
        let result = types[0].charAt(0).toUpperCase() + types[0].slice(1);
        for (let i = 1; i < types.length; i++) {
            result += ', ' + types[i];
        }
        return result;
    }
};

const truncateString = (string, length) => {
    if (string.length > length) {
        return string.slice(0, length) + '...';
    }
    return string;
}

const isTwoArrayIdentical = (arrayOne, arrayTwo) => {
    if (arrayOne.length !== arrayTwo.length) return false;

    for (let i = 0; i < arrayOne.length; i++) {
        if (!arrayOne.includes(arrayTwo[i])) return false;
    }

    return true;
};

const arrayContainsValue = (array, value) => {
    return array.indexOf(value) >= 0;
};

const formatTimestampWithoutSeconds = (time) => {
    if (time instanceof dayjs) {
        return time.startOf('minute').format('YYYY-MM-DD HH:mm:ssZZ');
    } else {
        return dayjs(time).startOf('minute').format('YYYY-MM-DD HH:mm:ssZZ');
    }
};

const formatTimestamp = (time) => {
    // Don't add .tz() to this. It executes before the .tz() method is defined.
    if (time instanceof dayjs) {
        return time.format('YYYY-MM-DD HH:mm:ssZZ');
    } else {
        return dayjs(time).format('YYYY-MM-DD HH:mm:ssZZ');
    }
};

const formatTimestampStartOfDay = (time) => {
    return formatTimestamp(dayjs(time.tz().startOf('day')));
}

const formatTimestampEndOfDay = (time) => {
    return formatTimestamp(dayjs(time.tz().endOf('day')));
}

const formatDate = (time) => {
    if (time instanceof dayjs) {
        return time.format('YYYY-MM-DD');
    } else {
        return dayjs(time).format('YYYY-MM-DD');
    }
}

const roundNumberUpToPrecision = (number, maxDecimals = 6) => {
    if (typeof number !== 'number') return null;

    const precisionBase = Math.pow(10, maxDecimals);

    return Math.round(number * precisionBase) / precisionBase;
};

const getRandomInt = (min, max) => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
};

const sumArr = (arr) => {
    return arr.reduce((partialSum, a) => partialSum + a, 0)
}

//duration calculation

/**
 * This function calculates difference between two timestamp or dayjs objects.
 * It is timezone agnostic, based on back end architecture.
 *
 * @param startedAt
 * @param endedAt
 * @returns {string}
 */
const getTimeDiff = (startedAt, endedAt) => {

    const startTime = startedAt instanceof dayjs ? startedAt.clone() : dayjs(startedAt).clone();
    const endTime = endedAt instanceof dayjs ? endedAt.clone() : dayjs(endedAt).clone();
    let durationStr = '';

    let hours = endTime.diff(startTime, 'hours');
    let minutes = endTime.diff(startTime, 'minutes');

    // days will be calculated based on 24hours/day
    let days = Math.floor(hours/24);

    minutes %= 60;
    hours %= 24;

    if (days > 0) {
        durationStr += days + (days === 1 ? ' day ' : ' days ');
    }
    if (hours > 0) {
        durationStr += hours + (hours === 1 ? ' hour ' : ' hours ');
    }
    if (minutes > 0) {
        durationStr += minutes + (minutes === 1 ? ' minute ' : ' minutes ');
    }

    return durationStr;
}

const getLogo = () => {
    try {
        return require('../assets/logos/' + window.env.FILE_PREFIX + '.png');
    } catch (e) {

    }
}

const sanitizeHTML = (htmlString) => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || '';
};

export {
    ucFirst,
    ucFirstArray,
    truncateString,
    isTwoArrayIdentical,
    arrayContainsValue,
    formatTimestamp,
    formatTimestampStartOfDay,
    formatTimestampEndOfDay,
    formatTimestampWithoutSeconds,
    formatDate,
    getRandomInt,
    sumArr,
    roundNumberUpToPrecision,
    getTimeDiff,
    getLogo,
    sanitizeHTML,
};
